/* eslint-disable import/no-unresolved */
import React, { ReactElement } from 'react';
import Plus from '../assets/icons/plus.svg?react';
import Minus from '../assets/icons/minus.svg?react';
import Menu from '../assets/icons/menu.svg?react';
import ChevronDown from '../assets/icons/chevron-down.svg?react';
import MessageCircle from '../assets/icons/message-circle.svg?react';
import Edit from '../assets/icons/edit.svg?react';
import MoreVertical from '../assets/icons/more-vertical.svg?react';
import PlusSquare from '../assets/icons/plus-square.svg?react';

import TaskNC from '../assets/ocd_type_icons/task-no-cloud.png';
import HarmNC from '../assets/ocd_type_icons/harm_no_cloud.png';
import ContaminationNC from '../assets/ocd_type_icons/contamination_no_cloud.png';
import OrderSymmetryNC from '../assets/ocd_type_icons/order_symmetry_no_cloud.png';
import PerfectionismNC from '../assets/ocd_type_icons/perfectionism_no_cloud.png';
import RelationshipNC from '../assets/ocd_type_icons/relationship_no_cloud.png';
import ScrupulosityNC from '../assets/ocd_type_icons/scrupulosity_no_cloud.png';
import SexualOrientationNC from '../assets/ocd_type_icons/sexual_orientation_no_cloud.png';
import SomaticNC from '../assets/ocd_type_icons/somatic_no_cloud.png';
import { Colors } from './Colors';

export const Icons = {
  plus: <Plus stroke="black" />,
  minus: <Minus stroke="black" />,
  menu: <Menu stroke="black" />,
  chevronDown: <ChevronDown stroke="black" />,
  messageCircle: <MessageCircle stroke="black" />,
  edit: <Edit stroke={Colors.silverSand} />,
  moreVertical: <MoreVertical stroke={Colors.silverSand} />,
  plusSquare: <PlusSquare stroke={Colors.silverSand} height="35" width="35" />
};
export type ocdTypes =
  | 'harm'
  | 'contamination'
  | 'orderSymmetry'
  | 'perfectionism'
  | 'relationship'
  | 'scrupulosity'
  | 'sexualOrientation'
  | 'somatic';

export function OCDTypeToImage(key: string): ocdTypes | 'none' {
  return (
    ({
      Contamination: 'contamination',
      Harm: 'harm',
      'Order & Symmetry': 'orderSymmetry',
      Perfectionism: 'perfectionism',
      Relationship: 'relationship',
      Scrupulosity: 'scrupulosity',
      'Sexual Orientation': 'SexualOrientation',
      Somatic: 'somatic'
    }[key] as ocdTypes) || 'none'
  );
}

export const OcdTypeNoCloudImages: Record<ocdTypes | 'none', ReactElement> = {
  none: <img src={TaskNC} alt="task" style={{ width: '100%' }} />,
  harm: <img src={HarmNC} alt="ocd type" style={{ width: '100%' }} />,
  contamination: (
    <img src={ContaminationNC} alt="ocd type" style={{ width: 100 }} />
  ),
  orderSymmetry: (
    <img src={OrderSymmetryNC} alt="ocd type" style={{ width: 100 }} />
  ),
  perfectionism: (
    <img src={PerfectionismNC} alt="ocd type" style={{ width: 100 }} />
  ),
  relationship: (
    <img src={RelationshipNC} alt="ocd type" style={{ width: 100 }} />
  ),
  scrupulosity: (
    <img src={ScrupulosityNC} alt="ocd type" style={{ width: 100 }} />
  ),
  sexualOrientation: (
    <img src={SexualOrientationNC} alt="ocd type" style={{ width: 100 }} />
  ),
  somatic: <img src={SomaticNC} alt="ocd type" style={{ width: 100 }} />
};
